import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../allcss/blog2.css';
import blogImage from '../Asets/Blog.jpg';
import blog1 from '../Asets/Blog12.png';
import Header from '../components/header';
import Footer from '../components/footer';

const Blog = () => {
  const navigate = useNavigate();

  return (
    <>
      <Header />
      <div className="blog-section">
        {/* Hero Section */}
        <div className="blog-hero" style={{ backgroundImage: `url(${blogImage})` }}>
          <div className="blog-overlay">
            <h1 className="blog-title">Our Blog</h1>
            <p className="breadcrumb">
              <span
                style={{ cursor: 'pointer', color: '#fff' }}
                onClick={() => navigate('/')}
              >
                Home
              </span>
              <span> / Our Blog</span>
            </p>
          </div>
        </div>

        {/* Blog Detail */}
        <div className="blog-container">
          <h2 className="section-title">Short Moral Stories for Kids in English (Ages 4–10)</h2>
         <br />
          <div className="published-badge">Published on: 27 July 2025</div>

          <img src={blog1} alt="Short Moral Stories" className="blog-detail-img" />

          <div className="blog-detail-content">
            <p><strong>Looking for inspiring short stories for children that teach valuable life lessons?</strong></p>
            <p>Here are 12 classic moral tales, perfect for kids aged 4 to 10. Each story comes with a simple message that helps children develop good values.</p>

            <ul>
              <li><strong>1. The Lion and the Mouse</strong><br />A little mouse accidentally wakes a sleeping lion...<br /><em>Moral: No act of kindness is ever wasted.</em></li><br />
              <li><strong>2. The Thirsty Crow</strong><br />A clever crow drops pebbles in a pot to drink water.<br /><em>Moral: Where there is a will, there is a way.</em></li><br />
              <li><strong>3. The Fox and the Grapes</strong><br />A hungry fox fails to reach grapes and calls them sour.<br /><em>Moral: It’s easy to despise what you can’t have.</em></li><br />
              <li><strong>4. The Tortoise and the Hare</strong><br />The slow tortoise wins the race as the hare naps.<br /><em>Moral: Slow and steady wins the race.</em></li><br />
              <li><strong>5. The Boy Who Cried Wolf</strong><br />A boy lies about wolves; nobody believes him when it’s true.<br /><em>Moral: Liars are not believed, even when truthful.</em></li><br />
              <li><strong>6. The Golden Egg</strong><br />A greedy farmer kills his goose, losing golden eggs.<br /><em>Moral: Greed leads to loss.</em></li><br />
              <li><strong>7. The Clever Monkey</strong><br />A monkey tricks a crocodile to escape danger.<br /><em>Moral: Wit can overcome strength.</em></li><br />
              <li><strong>8. The Bundle of Sticks</strong><br />Sons learn unity is strength through unbreakable sticks.</li><br />
              <li><strong>9. The Dog and His Reflection</strong><br />A dog loses its bone chasing a reflection.<br /><em>Moral: Don’t be greedy.</em></li><br />
              <li><strong>10. The Honest Woodcutter</strong><br />A woodcutter chooses honesty over gold axes.<br /><em>Moral: Honesty is the best policy.</em></li><br />
              <li><strong>11. The Foolish Dog</strong><br />A dog loses his bone due to greed.<br /><em>Moral: Be content with what you have.</em></li><br />
              <li><strong>12. The Cap Seller and the Monkeys</strong><br />A cap seller cleverly retrieves his caps from monkeys.<br /><em>Moral: Use your brain to solve problems.</em></li><br />
            </ul>

            <p>This post is brought to you by <strong>RedSchoolhouse Vadodara</strong> — nurturing young minds through inspiring stories and value-based learning. Enroll today!</p>

            {/* Go Back Button */}
            <div className="back-to-blogs-btn-wrapper">
              <button
                className="back-to-blogs-btn"
                onClick={() => navigate('/blog')}
              >
                Go Back To Blogs
              </button>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Blog;
